import ApiService from "@/common/services/http/api.service";

const BlacklistService = {
  /**
   * Buscar ScoreCards
   * @param clienteID id do grupo
   * @returns {*}
   */
  async getBlacklistByCliente(clienteID) {
    const { data: result } = await ApiService.get(
      "/Blacklist/BlacklistByCliente",
      `${clienteID}`
    );

    return result;
  },
};

export default BlacklistService;
